import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnalysisPreviewDialogComponent } from './analysis-preview-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {SvgIconModule} from '@toro/common/shared/components/svg-icon/svg-icon.module';

@NgModule({
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    imports: [CommonModule, MatSlideToggleModule, SvgIconModule],
    declarations: [ AnalysisPreviewDialogComponent ],
    entryComponents: [ AnalysisPreviewDialogComponent ],
    providers: [],
})

export class AnalysisPreviewDialogModule {}
